import AlabamaDesktop from "assets/images/slp/SDC-SLP-Header-Alabama.svg";
import AlaskaDesktop from "assets/images/slp/SDC-SLP-Header-Alaska.svg";
import ArizonaDesktop from "assets/images/slp/SDC-SLP-Header-Arizona.svg";
import ArkansasDesktop from "assets/images/slp/SDC-SLP-Header-Arkansas.svg";
import CaliforniaDesktop from "assets/images/slp/SDC-SLP-Header-California.svg";
import ColoradoDesktop from "assets/images/slp/SDC-SLP-Header-Colorado.svg";
import ConnecticutDesktop from "assets/images/slp/SDC-SLP-Header-Connecticut.svg";
import DelawareDesktop from "assets/images/slp/SDC-SLP-Header-Delaware.svg";
import FloridaDesktop from "assets/images/slp/SDC-SLP-Header-Florida.svg";
import GeorgiaDesktop from "assets/images/slp/SDC-SLP-Header-Georgia.svg";
import HawaiiDesktop from "assets/images/slp/SDC-SLP-Header-Hawaii.svg";
import IdahoDesktop from "assets/images/slp/SDC-SLP-Header-Idaho.svg";
import IllinoisDesktop from "assets/images/slp/SDC-SLP-Header-Illinois.svg";
import IndianaDesktop from "assets/images/slp/SDC-SLP-Header-Indiana.svg";
import IowaDesktop from "assets/images/slp/SDC-SLP-Header-Iowa.svg";
import KansasDesktop from "assets/images/slp/SDC-SLP-Header-Kansas.svg";
import KentuckyDesktop from "assets/images/slp/SDC-SLP-Header-Kentucky.svg";
import LouisianaDesktop from "assets/images/slp/SDC-SLP-Header-Louisiana.svg";
import MaineDesktop from "assets/images/slp/SDC-SLP-Header-Maine.svg";
import MarylandDesktop from "assets/images/slp/SDC-SLP-Header-Maryland.svg";
import MassachusettsDesktop from "assets/images/slp/SDC-SLP-Header-Massachusetts.svg";
import MichiganDesktop from "assets/images/slp/SDC-SLP-Header-Michigan.svg";
import MinnesotaDesktop from "assets/images/slp/SDC-SLP-Header-Minnesota.svg";
import MississippiDesktop from "assets/images/slp/SDC-SLP-Header-Mississippi.svg";
import MissouriDesktop from "assets/images/slp/SDC-SLP-Header-Missouri.svg";
import MontanaDesktop from "assets/images/slp/SDC-SLP-Header-Montana.svg";
import NebraskaDesktop from "assets/images/slp/SDC-SLP-Header-Nebraska.svg";
import NevadaDesktop from "assets/images/slp/SDC-SLP-Header-Nevada.svg";
import NewHampshireDesktop from "assets/images/slp/SDC-SLP-Header-NewHampshire.svg";
import NewJerseyDesktop from "assets/images/slp/SDC-SLP-Header-NewJersey.svg";
import NewMexicoDesktop from "assets/images/slp/SDC-SLP-Header-NewMexico.svg";
import NewYorkDesktop from "assets/images/slp/SDC-SLP-Header-NewYork.svg";
import NorthCarolinaDesktop from "assets/images/slp/SDC-SLP-Header-NorthCarolina.svg";
import NorthDakotaDesktop from "assets/images/slp/SDC-SLP-Header-NorthDakota.svg";
import OhioDesktop from "assets/images/slp/SDC-SLP-Header-Ohio.svg";
import OklahomaDesktop from "assets/images/slp/SDC-SLP-Header-Oklahoma.svg";
import OregonDesktop from "assets/images/slp/SDC-SLP-Header-Oregon.svg";
import PennsylvaniaDesktop from "assets/images/slp/SDC-SLP-Header-Pennsylvania.svg";
import RhodeIslandDesktop from "assets/images/slp/SDC-SLP-Header-RhodeIsland.svg";
import SouthCarolinaDesktop from "assets/images/slp/SDC-SLP-Header-SouthCarolina.svg";
import SouthDakotaDesktop from "assets/images/slp/SDC-SLP-Header-SouthDakota.svg";
import TennesseeDesktop from "assets/images/slp/SDC-SLP-Header-Tennessee.svg";
import TexasDesktop from "assets/images/slp/SDC-SLP-Header-Texas.svg";
import UtahDesktop from "assets/images/slp/SDC-SLP-Header-Utah.svg";
import VermontDesktop from "assets/images/slp/SDC-SLP-Header-Vermont.svg";
import VirginiaDesktop from "assets/images/slp/SDC-SLP-Header-Virginia.svg";
import WashingtonDesktop from "assets/images/slp/SDC-SLP-Header-Washington.svg";
import WestVirginiaDesktop from "assets/images/slp/SDC-SLP-Header-WestVirginia.svg";
import WisconsinDesktop from "assets/images/slp/SDC-SLP-Header-Wisconsin.svg";
import WyomingDesktop from "assets/images/slp/SDC-SLP-Header-Wyoming.svg";

import AlabamaMobile from "assets/images/slp/mobile/Alabama.svg";
import AlaskaMobile from "assets/images/slp/mobile/Alaska.svg";
import ArizonaMobile from "assets/images/slp/mobile/Arizona.svg";
import ArkansasMobile from "assets/images/slp/mobile/Arkansas.svg";
import CaliforniaMobile from "assets/images/slp/mobile/California.svg";
import ColoradoMobile from "assets/images/slp/mobile/Colorado.svg";
import ConnecticutMobile from "assets/images/slp/mobile/Connecticut.svg";
import DelawareMobile from "assets/images/slp/mobile/Delaware.svg";
import FloridaMobile from "assets/images/slp/mobile/Florida.svg";
import GeorgiaMobile from "assets/images/slp/mobile/Georgia.svg";
import HawaiiMobile from "assets/images/slp/mobile/Hawaii.svg";
import IdahoMobile from "assets/images/slp/mobile/Idaho.svg";
import IllinoisMobile from "assets/images/slp/mobile/Illinois.svg";
import IndianaMobile from "assets/images/slp/mobile/Indiana.svg";
import IowaMobile from "assets/images/slp/mobile/Iowa.svg";
import KansasMobile from "assets/images/slp/mobile/Kansas.svg";
import KentuckyMobile from "assets/images/slp/mobile/Kentucky.svg";
import LouisianaMobile from "assets/images/slp/mobile/Louisiana.svg";
import MaineMobile from "assets/images/slp/mobile/Maine.svg";
import MarylandMobile from "assets/images/slp/mobile/Maryland.svg";
import MassachusettsMobile from "assets/images/slp/mobile/Massachusetts.svg";
import MichiganMobile from "assets/images/slp/mobile/Michigan.svg";
import MinnesotaMobile from "assets/images/slp/mobile/Minnesota.svg";
import MississippiMobile from "assets/images/slp/mobile/Mississippi.svg";
import MissouriMobile from "assets/images/slp/mobile/Missouri.svg";
import MontanaMobile from "assets/images/slp/mobile/Montana.svg";
import NebraskaMobile from "assets/images/slp/mobile/Nebraska.svg";
import NevadaMobile from "assets/images/slp/mobile/Nevada.svg";
import NewHampshireMobile from "assets/images/slp/mobile/NewHampshire.svg";
import NewJerseyMobile from "assets/images/slp/mobile/NewJersey.svg";
import NewMexicoMobile from "assets/images/slp/mobile/NewMexico.svg";
import NewYorkMobile from "assets/images/slp/mobile/NewYork.svg";
import NorthCarolinaMobile from "assets/images/slp/mobile/NorthCarolina.svg";
import NorthDakotaMobile from "assets/images/slp/mobile/NorthDakota.svg";
import OhioMobile from "assets/images/slp/mobile/Ohio.svg";
import OklahomaMobile from "assets/images/slp/mobile/Oklahoma.svg";
import OregonMobile from "assets/images/slp/mobile/Oregon.svg";
import PennsylvaniaMobile from "assets/images/slp/mobile/Pennsylvania.svg";
import RhodeIslandMobile from "assets/images/slp/mobile/RhodeIsland.svg";
import SouthCarolinaMobile from "assets/images/slp/mobile/SouthCarolina.svg";
import SouthDakotaMobile from "assets/images/slp/mobile/SouthDakota.svg";
import TennesseeMobile from "assets/images/slp/mobile/Tennessee.svg";
import TexasMobile from "assets/images/slp/mobile/Texas.svg";
import UtahMobile from "assets/images/slp/mobile/Utah.svg";
import VermontMobile from "assets/images/slp/mobile/Vermont.svg";
import VirginiaMobile from "assets/images/slp/mobile/Virginia.svg";
import WashingtonMobile from "assets/images/slp/mobile/Washington.svg";
import WestVirginiaMobile from "assets/images/slp/mobile/WestVirginia.svg";
import WisconsinMobile from "assets/images/slp/mobile/Wisconsin.svg";
import WyomingMobile from "assets/images/slp/mobile/Wyoming.svg";

const STATE_HERO_IMAGES = {
	alabama: { desktop: AlabamaDesktop, mobile: AlabamaMobile },
	alaska: { desktop: AlaskaDesktop, mobile: AlaskaMobile },
	arizona: { desktop: ArizonaDesktop, mobile: ArizonaMobile },
	arkansas: { desktop: ArkansasDesktop, mobile: ArkansasMobile },
	california: { desktop: CaliforniaDesktop, mobile: CaliforniaMobile },
	colorado: { desktop: ColoradoDesktop, mobile: ColoradoMobile },
	connecticut: { desktop: ConnecticutDesktop, mobile: ConnecticutMobile },
	delaware: { desktop: DelawareDesktop, mobile: DelawareMobile },
	florida: { desktop: FloridaDesktop, mobile: FloridaMobile },
	georgia: { desktop: GeorgiaDesktop, mobile: GeorgiaMobile },
	hawaii: { desktop: HawaiiDesktop, mobile: HawaiiMobile },
	idaho: { desktop: IdahoDesktop, mobile: IdahoMobile },
	illinois: { desktop: IllinoisDesktop, mobile: IllinoisMobile },
	indiana: { desktop: IndianaDesktop, mobile: IndianaMobile },
	iowa: { desktop: IowaDesktop, mobile: IowaMobile },
	kansas: { desktop: KansasDesktop, mobile: KansasMobile },
	kentucky: { desktop: KentuckyDesktop, mobile: KentuckyMobile },
	louisiana: { desktop: LouisianaDesktop, mobile: LouisianaMobile },
	maine: { desktop: MaineDesktop, mobile: MaineMobile },
	maryland: { desktop: MarylandDesktop, mobile: MarylandMobile },
	massachusetts: { desktop: MassachusettsDesktop, mobile: MassachusettsMobile },
	michigan: { desktop: MichiganDesktop, mobile: MichiganMobile },
	minnesota: { desktop: MinnesotaDesktop, mobile: MinnesotaMobile },
	mississippi: { desktop: MississippiDesktop, mobile: MississippiMobile },
	missouri: { desktop: MissouriDesktop, mobile: MissouriMobile },
	montana: { desktop: MontanaDesktop, mobile: MontanaMobile },
	nebraska: { desktop: NebraskaDesktop, mobile: NebraskaMobile },
	nevada: { desktop: NevadaDesktop, mobile: NevadaMobile },
	"new-hampshire": { desktop: NewHampshireDesktop, mobile: NewHampshireMobile },
	"new-jersey": { desktop: NewJerseyDesktop, mobile: NewJerseyMobile },
	"new-mexico": { desktop: NewMexicoDesktop, mobile: NewMexicoMobile },
	"new-york": { desktop: NewYorkDesktop, mobile: NewYorkMobile },
	"north-carolina": { desktop: NorthCarolinaDesktop, mobile: NorthCarolinaMobile },
	"north-dakota": { desktop: NorthDakotaDesktop, mobile: NorthDakotaMobile },
	ohio: { desktop: OhioDesktop, mobile: OhioMobile },
	oklahoma: { desktop: OklahomaDesktop, mobile: OklahomaMobile },
	oregon: { desktop: OregonDesktop, mobile: OregonMobile },
	pennsylvania: { desktop: PennsylvaniaDesktop, mobile: PennsylvaniaMobile },
	"rhode-island": { desktop: RhodeIslandDesktop, mobile: RhodeIslandMobile },
	"south-carolina": { desktop: SouthCarolinaDesktop, mobile: SouthCarolinaMobile },
	"south-dakota": { desktop: SouthDakotaDesktop, mobile: SouthDakotaMobile },
	tennessee: { desktop: TennesseeDesktop, mobile: TennesseeMobile },
	texas: { desktop: TexasDesktop, mobile: TexasMobile },
	utah: { desktop: UtahDesktop, mobile: UtahMobile },
	vermont: { desktop: VermontDesktop, mobile: VermontMobile },
	virginia: { desktop: VirginiaDesktop, mobile: VirginiaMobile },
	washington: { desktop: WashingtonDesktop, mobile: WashingtonMobile },
	"west-virginia": { desktop: WestVirginiaDesktop, mobile: WestVirginiaMobile },
	wisconsin: { desktop: WisconsinDesktop, mobile: WisconsinMobile },
	wyoming: { desktop: WyomingDesktop, mobile: WyomingMobile },
};

export default STATE_HERO_IMAGES;
